export default "__VITE_ASSET__DValDxY___"